import {ApiSlice} from "@/store/ApiSlice";
import RESTAPIConfig from "@/config/RESTAPIConfig";
import {NewBaseResponseInterface} from "@/common/Http/Interfaces/NewBaseResponseInterface";

const restApiConfig = new RESTAPIConfig();

interface CreateFileMeaningPayloadInterface {
    title: string;
    alias: string;
    active: boolean;
}

export const CreateFileMeaningsApiSlice = ApiSlice.injectEndpoints({
    endpoints: builder => ({
        createFileMeaning: builder.mutation<NewBaseResponseInterface<unknown, unknown>, CreateFileMeaningPayloadInterface>({
            query: (body) => ({
                url: restApiConfig.baseUrl + restApiConfig.apiPrefixV2 + restApiConfig.fileMeaning(),
                method: 'POST',
                body,
            }),
            invalidatesTags: (result, error) => {
                if (!error) {
                    return ["FileMeanings"];
                }
                return [];
            }
        })
    })
});

export const {useCreateFileMeaningMutation} = CreateFileMeaningsApiSlice;
